(function () {
  'use strict';

  var form = document.querySelector('.contact-desk__form');
  if (!form || typeof URLSearchParams === 'undefined') return;

  var formOpenedAt = Date.now();

  var params = new URLSearchParams(window.location.search);
  var product = params.get('product') || '';
  var part = params.get('part') || '';
  var sku = params.get('sku') || '';
  var productUrl = params.get('product_url') || '';
  var variant = params.get('variant') || '';
  var topic = params.get('topic') || '';
  var priceCents = Number(params.get('price_cents') || 0);
  var currency = params.get('currency') || 'USD';

  function normalizeProductUrl(value) {
    if (!value) return '';
    try {
      var parsed = new URL(value, window.location.origin);
      if (parsed.pathname.indexOf('/products/') !== 0) return '';
      return parsed.origin + parsed.pathname;
    } catch (_) {
      return '';
    }
  }

  productUrl = normalizeProductUrl(productUrl) || normalizeProductUrl(document.referrer);

  function setValue(selector, value) {
    var field = form.querySelector(selector);
    if (field && value) field.value = value;
  }

  setValue('[data-contact-product]', product);
  setValue('[data-contact-part]', part);
  setValue('[data-contact-sku]', sku);
  setValue('[data-contact-product-url]', productUrl);
  setValue('[data-contact-variant]', variant);
  setValue('[data-contact-product-reference]', product || part || sku);
  setValue('[data-contact-manual-product-url]', productUrl);

  var alliancePrice = '';
  if (Number.isFinite(priceCents) && priceCents > 0) {
    try {
      alliancePrice = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(priceCents / 100);
    } catch (_) {
      alliancePrice = (priceCents / 100).toFixed(2) + ' ' + currency;
    }
  }
  setValue('[data-contact-alliance-price]', alliancePrice);

  function normalizedRequestedTopic(value) {
    var requestedTopic = String(value || '').trim().toLowerCase();

    // Keep older policy links working while routing every return-related request
    // through the single customer-facing Returns or warranty workflow.
    if (requestedTopic === 'return request' ||
      requestedTopic === 'damaged, defective, or incorrect item') {
      return 'returns or warranty';
    }

    return requestedTopic;
  }

  var topicSelect = form.querySelector('[data-contact-topic]');
  if (topicSelect && topic) {
    var requestedTopic = normalizedRequestedTopic(topic);
    Array.from(topicSelect.options).some(function (option) {
      if (option.textContent.trim().toLowerCase() !== requestedTopic) return false;
      option.selected = true;
      return true;
    });
  }

  var priceMatchFields = form.querySelector('[data-price-match-fields]');
  var priceMatchRequired = priceMatchFields ? priceMatchFields.querySelectorAll('[data-price-match-required]') : [];
  var fitmentFields = form.querySelector('[data-fitment-fields]');
  var fitmentRequired = fitmentFields ? fitmentFields.querySelectorAll('[data-fitment-required]') : [];
  var productReferenceFields = form.querySelector('[data-product-reference-fields]');
  var productReference = form.querySelector('[data-contact-product-reference]');
  var manualProductUrl = form.querySelector('[data-contact-manual-product-url]');
  var orderNumber = form.querySelector('[data-order-number]');
  var orderNumberLabel = form.querySelector('[data-order-number-label]');
  var submit = form.querySelector('[data-contact-submit]');
  var body = form.querySelector('[data-contact-body]');
  var bodyLabel = form.querySelector('[data-contact-body-label]');
  var status = form.querySelector('[data-contact-status]');
  var honeypot = form.querySelector('[data-contact-honeypot]');

  function isPriceMatch() {
    return topicSelect && topicSelect.value.trim().toLowerCase() === 'price match request';
  }

  function isFitmentQuestion() {
    return topicSelect && topicSelect.value.trim().toLowerCase() === 'product or fitment question';
  }

  function normalizedTopic() {
    return topicSelect ? topicSelect.value.trim().toLowerCase() : '';
  }

  function needsProductReference() {
    var currentTopic = normalizedTopic();
    return currentTopic === 'product or fitment question' ||
      currentTopic === 'availability or lead time' ||
      currentTopic === 'price match request';
  }

  function needsOrderNumber() {
    var currentTopic = normalizedTopic();
    return currentTopic === 'existing order' ||
      currentTopic === 'shipping or tracking' ||
      currentTopic === 'returns or warranty';
  }

  function updateTopicFields() {
    var priceMatch = isPriceMatch();
    var fitmentQuestion = isFitmentQuestion();
    var productReferenceRequired = needsProductReference();
    var orderNumberRequired = needsOrderNumber();
    if (productReferenceFields) productReferenceFields.hidden = !productReferenceRequired;
    if (productReference) {
      productReference.required = productReferenceRequired;
      productReference.disabled = !productReferenceRequired;
    }
    if (manualProductUrl) manualProductUrl.disabled = !productReferenceRequired;
    if (orderNumber) {
      orderNumber.required = orderNumberRequired;
      orderNumber.placeholder = orderNumberRequired ? 'Required' : 'Optional';
    }
    if (orderNumberLabel) orderNumberLabel.textContent = orderNumberRequired ? 'Order number *' : 'Order number';
    if (priceMatchFields) priceMatchFields.hidden = !priceMatch;
    Array.from(priceMatchRequired).forEach(function (field) {
      field.required = priceMatch;
      field.disabled = !priceMatch;
    });
    if (fitmentFields) fitmentFields.hidden = !fitmentQuestion;
    Array.from(fitmentRequired).forEach(function (field) {
      field.required = fitmentQuestion;
    });
    if (fitmentFields) {
      Array.from(fitmentFields.querySelectorAll('input')).forEach(function (field) {
        field.disabled = !fitmentQuestion;
      });
    }
    if (bodyLabel) {
      bodyLabel.textContent = priceMatch
        ? 'Additional price-match details *'
        : fitmentQuestion
          ? 'Fitment question or relevant modifications *'
          : 'Message or additional details *';
    }
    if (body) {
      body.placeholder = priceMatch
        ? 'Add any details that affect the comparison, such as shipping or an exact option.'
        : fitmentQuestion
          ? 'Describe what you want verified and list any modifications that may affect fitment.'
          : 'Tell us what you need help with.';
    }
    if (submit) submit.textContent = priceMatch ? 'Submit price match request' : 'Send message';
  }

  if (topicSelect) topicSelect.addEventListener('change', updateTopicFields);
  updateTopicFields();

  function refreshProductContext() {
    var currentParams = new URLSearchParams(window.location.search);
    product = currentParams.get('product') || product;
    part = currentParams.get('part') || part;
    sku = currentParams.get('sku') || sku;
    variant = currentParams.get('variant') || variant;
    productUrl = normalizeProductUrl(currentParams.get('product_url')) || productUrl;
    priceCents = Number(currentParams.get('price_cents') || priceCents || 0);
    currency = currentParams.get('currency') || currency;

    if (Number.isFinite(priceCents) && priceCents > 0) {
      try {
        alliancePrice = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(priceCents / 100);
      } catch (_) {
        alliancePrice = (priceCents / 100).toFixed(2) + ' ' + currency;
      }
    }

    setValue('[data-contact-product]', product);
    setValue('[data-contact-part]', part);
    setValue('[data-contact-sku]', sku);
    setValue('[data-contact-product-url]', productUrl);
    setValue('[data-contact-variant]', variant);
    setValue('[data-contact-alliance-price]', alliancePrice);
    setValue('[data-contact-product-reference]', product || part || sku);
    setValue('[data-contact-manual-product-url]', productUrl);
  }

  function fieldValue(selector) {
    var field = form.querySelector(selector);
    return field ? field.value.trim() : '';
  }

  function subjectSafe(value) {
    return String(value || '')
      .replace(/&/g, 'and')
      .replace(/\//g, '∕')
      .replace(/'/g, '’')
      .replace(/"/g, '”')
      .replace(/</g, '(')
      .replace(/>/g, ')')
      .replace(/[\r\n\t]+/g, ' ')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function setStatus(type, message) {
    if (!status) return;
    status.className = 'contact-desk__delivery-status contact-desk__delivery-status--' + type;
    status.innerHTML = message;
    status.hidden = false;
    status.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function setBusy(busy) {
    if (!submit) return;
    submit.disabled = busy;
    submit.setAttribute('aria-busy', busy ? 'true' : 'false');
    if (busy) {
      submit.dataset.label = submit.textContent;
      submit.textContent = 'Sending…';
    } else if (submit.dataset.label) {
      submit.textContent = submit.dataset.label;
      delete submit.dataset.label;
    }
  }

  function emailJsConfig() {
    return {
      enabled: form.dataset.emailjsEnabled === 'true',
      service: form.dataset.emailjsService || '',
      template: form.dataset.emailjsTemplate || '',
      publicKey: form.dataset.emailjsPublicKey || ''
    };
  }

  function templateParams() {
    var requestType = fieldValue('[data-contact-topic]') || 'Parts Desk request';
    var customerName = fieldValue('[name="contact[name]"]');
    var productTitle = fieldValue('[data-contact-product]') || fieldValue('[data-contact-product-reference]');
    var submittedProductUrl = fieldValue('[data-contact-product-url]') || fieldValue('[data-contact-manual-product-url]');
    return {
      email_subject: '[' + subjectSafe(requestType) + '] ' + (productTitle ? subjectSafe(productTitle) + ' — ' : '') + subjectSafe(customerName),
      request_type: requestType,
      customer_name: customerName,
      customer_email: fieldValue('[name="contact[email]"]'),
      customer_phone: fieldValue('[name="contact[phone]"]'),
      order_number: fieldValue('[name="contact[Order number]"]'),
      product_title: productTitle,
      mpn: fieldValue('[data-contact-part]'),
      sku: fieldValue('[data-contact-sku]'),
      product_url: submittedProductUrl,
      variant_id: fieldValue('[data-contact-variant]'),
      alliance_price: fieldValue('[data-contact-alliance-price]'),
      vehicle: fieldValue('[name="contact[Vehicle]"]'),
      destination_zip: fieldValue('[name="contact[Destination ZIP]"]'),
      competitor_name: fieldValue('[name="contact[Competitor name]"]'),
      competitor_price: fieldValue('[name="contact[Competitor advertised price]"]'),
      competitor_url: fieldValue('[name="contact[Competitor product URL]"]'),
      message: fieldValue('[data-contact-body]'),
      submitted_at: new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date()),
      page_url: window.location.href.split('#')[0]
    };
  }

  function finishEmailJsSuccess() {
    setBusy(false);
    form.classList.add('is-sent');
    setStatus('success', '<strong>Request sent.</strong> Thanks—your message is with the Alliance Racing Parts Desk. We’ll follow up shortly.');
  }

  form.addEventListener('submit', function (event) {
    refreshProductContext();

    var config = emailJsConfig();
    if (!config.enabled || !config.service || !config.template || !config.publicKey) {
      form.querySelectorAll('input[type="hidden"][data-contact-product], input[type="hidden"][data-contact-part], input[type="hidden"][data-contact-sku], input[type="hidden"][data-contact-product-url], input[type="hidden"][data-contact-variant], input[type="hidden"][data-contact-alliance-price]').forEach(function (field) {
        field.disabled = !field.value.trim();
      });
      return;
    }

    event.preventDefault();
    if (!form.reportValidity()) return;

    if ((honeypot && honeypot.value) || Date.now() - formOpenedAt < 700) {
      finishEmailJsSuccess();
      return;
    }

    setBusy(true);
    if (status) status.hidden = true;

    fetch('https://api.emailjs.com/api/v1.0/email/send', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        service_id: config.service,
        template_id: config.template,
        user_id: config.publicKey,
        template_params: templateParams()
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.text().then(function (message) {
          throw new Error(message || 'EmailJS request failed');
        });
      }
      finishEmailJsSuccess();
    }).catch(function (error) {
      setBusy(false);
      setStatus('error', '<strong>That did not send.</strong> Please try again, or email <a href="mailto:sales@allianceracing.com">sales@allianceracing.com</a>.');
      try { console.error('[parts desk email]', error); } catch (_) {}
    });
  });
})();
